export default {"src":"/_next/static/media/sheriff-octopus.1da32704.svg","height":92,"width":104};